// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nF-z","hovered":"oF-z","hoverImage":"pF-z","mainImage":"qF-z","imageNoBackground":"rF-z","fullSizeImage":"sF-z"};